// sc-142144: read the user's assigned Explore search-prompt cohort from
// `window.App.searchPromptCohort`. Emitted by the Rails side in
// `_js_context.html.erb` via `SearchPromptExperimentConcern#search_prompt_cohort`.
//
// Returns "" when:
//   - the experiment flag is off (`SEARCH_PROMPT_EXPERIMENT_ENABLED=false`)
//   - the user has never been bucketed (i.e. never hit Explore)
//   - the user is filtered out by Split's `ignore_filter` (bot, native mobile app)
//
// Use it as an event property on Mixpanel events that we want to slice
// by cohort: `Search Performed`, `Search Result Clicked`,
// `Applet Enable Completed`.
export const getSearchPromptCohort = (): string =>
  ((window as any).App?.searchPromptCohort as string) ?? ""
